import { DeleteRowConfirmationDialog } from "@/components/ax/dataTable/DeleteRowConfirmationDialog";
import { PermissionChecker2 } from "@/components/permission/PermissionChecker2";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { showSuccess, showApiError } from "@/lib/toast";
import { deleteBlogPost } from "@/sideEffects/api";
import { useMutation } from "@tanstack/react-query";
import { t } from "i18next";

interface Props {
  blogPostId: string;
}

export const DeleteBlogPostButton = ({ blogPostId }: Props) => {
  const { goToAllergy } = useAppNavigate();
  const deleteBlogPostMutation = useMutation({
    mutationFn: (blogPostId: string) => deleteBlogPost(blogPostId),
    onSuccess: () => {
      showSuccess(t("common.deletedSuccess"));
      goToAllergy();
    },
    onError: showApiError,
  });

  return (
    <PermissionChecker2 entity="BlogPost" rights={["Delete"]}>
      <DeleteRowConfirmationDialog
        onConfirmDelete={() => deleteBlogPostMutation.mutate(blogPostId)}
        isLoading={deleteBlogPostMutation.isPending}
      />
    </PermissionChecker2>
  );
};
